import _taggedTemplateLiteral from "/home/runner/work/web/web/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";

var _templateObject, _templateObject2;

import { useRef, useState, useEffect, useCallback } from 'react';
import styled from 'styled-components';
import { media, pxToRem } from '@yoweb/ui/styles/utils';
import { Box } from '@yoweb/ui/components/Box';
import { jsx as _jsx } from "react/jsx-runtime";

var CardCarouselFixed = function CardCarouselFixed(_ref) {
  var id = _ref.id,
      _ref$cardGap = _ref.cardGap,
      cardGap = _ref$cardGap === void 0 ? 24 : _ref$cardGap,
      children = _ref.children,
      breakpoints = _ref.breakpoints,
      step = _ref.step,
      _ref$itemWidth = _ref.itemWidth,
      itemWidth = _ref$itemWidth === void 0 ? 0 : _ref$itemWidth,
      fluid = _ref.fluid,
      dataTestId = _ref['data-testid'];

  var _useState = useState(itemWidth),
      currentItemWidth = _useState[0],
      setCurrentItemWidth = _useState[1];

  var _useState2 = useState(0),
      sliderX = _useState2[0],
      setSliderX = _useState2[1];

  var parentRef = useRef(null);
  useEffect(function () {
    var handleResize = function handleResize() {
      if (!parentRef.current) {
        return;
      }

      if (!fluid) {
        // set container size and recalculate item width
        var parentWidth = parentRef.current.offsetWidth;
        var breakpoint = breakpoints.find(function (bp) {
          return parentWidth <= bp.width;
        });

        if (breakpoint) {
          var newItemWidth = (parentRef.current.offsetWidth - cardGap * (breakpoint === null || breakpoint === void 0 ? void 0 : breakpoint.itemsToShow)) / (breakpoint === null || breakpoint === void 0 ? void 0 : breakpoint.itemsToShow);
          setCurrentItemWidth(newItemWidth);
          setSliderX(-step * (newItemWidth + cardGap));
        }
      }
    };

    handleResize();
    step === 0 ? setSliderX(step) : setSliderX(-step * (currentItemWidth + cardGap));
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [cardGap, currentItemWidth, sliderX, breakpoints, step, fluid]);
  return /*#__PURE__*/_jsx(CarouselContainer, {
    "data-testid": dataTestId,
    children: /*#__PURE__*/_jsx(Carousel, {
      children: /*#__PURE__*/_jsx(SliderContainer, {
        ref: parentRef,
        children: /*#__PURE__*/_jsx(Slider, {
          "data-testid": "carousel-slider",
          style: {
            left: "".concat(sliderX, "px")
          },
          children: /*#__PURE__*/_jsx(Track, {
            cardGap: cardGap,
            children: currentItemWidth > 0 && (children === null || children === void 0 ? void 0 : children.map(function (card, index) {
              return (
                /*#__PURE__*/
                // eslint-disable-next-line react/no-array-index-key
                _jsx(Item, {
                  width: currentItemWidth,
                  children: card
                }, "".concat(id, "-").concat(index))
              );
            }))
          })
        })
      })
    })
  });
};

var useCarouselStepper = function useCarouselStepper(totalItems, externalParentRef, breakpoints) {
  var _useState3 = useState(false),
      forwardEnabled = _useState3[0],
      setForwardEnabled = _useState3[1];

  var _useState4 = useState(false),
      backwardEnabled = _useState4[0],
      setBackwardendabled = _useState4[1];

  var _useState5 = useState(0),
      currentStep = _useState5[0],
      setCurrentStep = _useState5[1];

  var _useState6 = useState(0),
      width = _useState6[0],
      setWidth = _useState6[1];

  var _useState7 = useState({
    width: -1,
    itemsToShow: 3
  }),
      breakpoint = _useState7[0],
      setBreakpoint = _useState7[1];

  useEffect(function () {
    var handleResize = function handleResize() {
      if (externalParentRef !== null && externalParentRef !== void 0 && externalParentRef.current && externalParentRef.current.offsetWidth !== width) {
        var currentWidth = externalParentRef.current.offsetWidth;
        setWidth(currentWidth);
        var bp = breakpoints.find(function (b) {
          return currentWidth <= b.width;
        });

        if (bp) {
          setBreakpoint(bp);
          var totalSteps = totalItems - bp.itemsToShow;
          setForwardEnabled(totalSteps > currentStep);
        }
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return function () {
      window.removeEventListener('resize', handleResize);
    };
  }, [breakpoints, externalParentRef, totalItems, width, currentStep]);

  var stepForward = function stepForward() {
    var totalSteps = totalItems - breakpoint.itemsToShow;
    var nextStep = currentStep + 1;
    setCurrentStep(nextStep);
    var remainingSteps = totalSteps - nextStep;

    if (remainingSteps === 0) {
      setForwardEnabled(false);
    }

    if (currentStep === 0) {
      setBackwardendabled(true);
    }
  };

  var stepBackward = function stepBackward() {
    var totalSteps = totalItems - (breakpoint === null || breakpoint === void 0 ? void 0 : breakpoint.itemsToShow);
    var nextStep = currentStep - 1;
    setCurrentStep(nextStep);
    var remainingSteps = totalSteps - nextStep;

    if (remainingSteps !== 0) {
      setForwardEnabled(true);
    }

    if (nextStep === 0) {
      setBackwardendabled(false);
    }
  };

  var stepTo = function stepTo(step) {
    var totalSteps = totalItems - (breakpoint === null || breakpoint === void 0 ? void 0 : breakpoint.itemsToShow);
    var nextStep = currentStep - 1;
    setCurrentStep(step);
    var remainingSteps = totalSteps - nextStep;

    if (remainingSteps !== 0) {
      setForwardEnabled(true);
    }

    if (nextStep === 0) {
      setBackwardendabled(false);
    }
  };

  return {
    forwardEnabled: forwardEnabled,
    backwardEnabled: backwardEnabled,
    onNext: stepForward,
    onPrevious: stepBackward,
    stepTo: stepTo,
    currentStep: currentStep
  };
};

var CardCarousel = function CardCarousel(_ref2) {
  var carouselRef = _ref2.carouselRef,
      children = _ref2.children,
      _ref2$cardGap = _ref2.cardGap,
      cardGap = _ref2$cardGap === void 0 ? 16 : _ref2$cardGap;
  return /*#__PURE__*/_jsx(CarouselWrapper, {
    cardGap: cardGap,
    ref: carouselRef,
    "data-testid": "card-carousel",
    children: children === null || children === void 0 ? void 0 : children.map(function (child, index) {
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _jsx(ChildContainer, {
          children: child
        }, "carousel-child-".concat(index))
      );
    })
  });
};

var useCardCarouselStepper = function useCardCarouselStepper(carouselRef) {
  var _useState8 = useState(true),
      isScrolledLeft = _useState8[0],
      setIsScrolledLeft = _useState8[1];

  var _useState9 = useState(false),
      isScrolledRight = _useState9[0],
      setIsScrolledRight = _useState9[1];

  var checkScroll = useCallback(function () {
    var carousel = carouselRef.current;

    if (!carousel) {
      return;
    }

    setIsScrolledLeft(carousel.scrollLeft === 0);
    setIsScrolledRight(Math.abs(carousel.scrollLeft - (carousel.scrollWidth - carousel.offsetWidth)) < 1);
  }, [carouselRef]);
  useEffect(function () {
    var carousel = carouselRef.current;
    carousel === null || carousel === void 0 ? void 0 : carousel.addEventListener('scroll', checkScroll);
    checkScroll();
    return function () {
      return carousel === null || carousel === void 0 ? void 0 : carousel.removeEventListener('scroll', checkScroll);
    };
  }, [carouselRef, checkScroll]);

  var scrollCarousel = function scrollCarousel(offset) {
    if (carouselRef.current) {
      carouselRef.current.scrollTo({
        left: carouselRef.current.scrollLeft + offset,
        behavior: 'smooth'
      });
    }
  };

  return {
    onNext: function onNext() {
      var _carouselRef$current$, _carouselRef$current;

      return scrollCarousel((_carouselRef$current$ = carouselRef === null || carouselRef === void 0 ? void 0 : (_carouselRef$current = carouselRef.current) === null || _carouselRef$current === void 0 ? void 0 : _carouselRef$current.offsetWidth) !== null && _carouselRef$current$ !== void 0 ? _carouselRef$current$ : 0);
    },
    onBack: function onBack() {
      var _carouselRef$current$2, _carouselRef$current2;

      return scrollCarousel(-((_carouselRef$current$2 = carouselRef === null || carouselRef === void 0 ? void 0 : (_carouselRef$current2 = carouselRef.current) === null || _carouselRef$current2 === void 0 ? void 0 : _carouselRef$current2.offsetWidth) !== null && _carouselRef$current$2 !== void 0 ? _carouselRef$current$2 : 0));
    },
    backwardEnabled: !isScrolledLeft,
    forwardEnabled: !isScrolledRight
  };
};

var ChildContainer = styled(Box).withConfig({
  componentId: "sc-1e1zeto-0"
})(["flex:0 0 auto;scroll-snap-align:start;scroll-snap-stop:always;width:100%;", " ", ""], media.md(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    width: 48.75%;\n  "]))), media.xl(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    width: 32%;\n  "]))));
var CarouselWrapper = styled.div.withConfig({
  componentId: "sc-1e1zeto-1"
})(["display:flex;overflow:auto hidden;padding-bottom:1.5px;scroll-snap-type:x mandatory;gap:", ";-ms-overflow-style:none;scrollbar-width:none;&::-webkit-scrollbar{display:none;}"], function (_ref3) {
  var cardGap = _ref3.cardGap;
  return pxToRem(cardGap);
});
var CarouselContainer = styled.div.withConfig({
  componentId: "sc-1e1zeto-2"
})(["width:100%;display:flex;align-items:center;direction:ltr;"]);
var Carousel = styled.div.withConfig({
  componentId: "sc-1e1zeto-3"
})(["display:flex;min-height:180px;flex-direction:row;width:100%;"]);
var SliderContainer = styled.div.withConfig({
  componentId: "sc-1e1zeto-4"
})(["overflow:hidden;position:relative;width:100%;"]);
var Slider = styled.div.withConfig({
  componentId: "sc-1e1zeto-5"
})(["transition:all 650ms ease 0s;top:auto;position:relative;display:flex;flex-direction:row;"]);
var Track = styled.div.withConfig({
  componentId: "sc-1e1zeto-6"
})(["display:flex;flex-direction:row;gap:", ";--card-gap:", ";--card-count:2;"], function (_ref4) {
  var cardGap = _ref4.cardGap;
  return pxToRem(cardGap);
}, function (_ref5) {
  var cardGap = _ref5.cardGap;
  return pxToRem(cardGap);
});
var Item = styled(Box).withConfig({
  componentId: "sc-1e1zeto-7"
})(["display:flex;will-change:transform;"]);
export { CardCarouselFixed, useCarouselStepper, CardCarousel, useCardCarouselStepper };